import React from 'react';
import HomepageSlider from './Slider';


const HomepageSection = (props: any) => {
        return (
            <HomepageSlider>
              {props.children}
            </HomepageSlider>
        )
}

export default HomepageSection;
//<div className="streamCards__list">
